import { IStudent } from '../../types/student';

export const groupStudentToCsv = (data: IStudent[]) => {
    const groupData: any = [
        [
            'id',
            'First Name',
            'Last Name',
            'Address',
            'Attorney First Name',
            'Attorney Last Name',
            'Attorney Email',
            'Parent First Name',
            'Parent Last Name',
            'Parent Email',
            'Parent Mobile Phone',
        ],
    ];

    data.forEach((it) => {
        groupData.push([
            it.id,
            it.firstName,
            it.lastName,
            it.address,
            it.attorneyFullName,
            it.attorneyPhoneNumber,
            it.attorneyPrimaryEmail,
            it.parentFirstName,
            it.parentLastName,
            it.parentPrimaryEmail,
            it.parentPhone,
        ]);
    });

    return groupData;
};
